/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/no-lock-1218396': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M10.84 5.38a2 2 0 012.57.21A2 2 0 0114 7v3a1 1 0 001 1h1a1 1 0 011 1v.34a1 1 0 002 0V12a3 3 0 00-3-3V7a4 4 0 00-1.17-2.83 4.06 4.06 0 00-5.19-.39 1 1 0 101.2 1.6zm10.87 14.91l-18-18a1 1 0 00-1.42 1.42L7.62 9A3 3 0 005 12v6a3 3 0 003 3h8a3 3 0 002.39-1.2l1.9 1.91a1 1 0 001.42 0 1 1 0 000-1.42zM16 19H8a1 1 0 01-1-1v-6a1 1 0 011-1h1.59l2.07 2.07A1 1 0 0011 14v2a1 1 0 002 0v-1.59l3.93 3.93A1 1 0 0116 19z"/>'
  }
})
